module.exports = __webpack_public_path__ + "img/doc_2_preview.24a737a5.jpg";